import { render, staticRenderFns } from "./scroll-to-top.vue?vue&type=template&id=f0bf5216&scoped=true"
import script from "./scroll-to-top.vue?vue&type=script&lang=js"
export * from "./scroll-to-top.vue?vue&type=script&lang=js"
import style0 from "./scroll-to-top.vue?vue&type=style&index=0&id=f0bf5216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bf5216",
  null
  
)

export default component.exports